<span class="font-medium-title-large">Freischalt-Code einlösen</span>

<form [formGroup]="form" class="align-self-stretch flex-c gap-16">
  <div class="flex-r gap-16">
    <div class="input-simple flex-1-1-0">
      <label for="code" class="input-label"> Code* </label>
      <input
        type="text"
        id="code"
        name="code"
        class="input-field"
        placeholder="Freischalt-Code eingeben"
        formControlName="code" />
      <app-error-message [formField]="form.get('code')"></app-error-message>
    </div>
  </div>
</form>

<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    class="inwi-icon-text-button-large-secondary"
    (click)="onCancel()">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-times"></i>
      </div>
      <div class="button-text">Abbrechen</div>
    </div>
  </button>
  <button
    type="button"
    [disabled]="form.invalid || isLoading"
    (click)="onRedeemCode()"
    class="inwi-icon-text-button-large-primary">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-floppy-disk"></i>
      </div>
      <div class="button-text">Einlösen</div>
    </div>
  </button>
</div>
